var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.SETTINGS.alert_message != null && _vm.closeAlertAction === false)?_c('div',[_c('v-alert',{staticClass:"app-alert-bar",attrs:{"dark":""}},[_vm._v(" "+_vm._s(_vm.SETTINGS.alert_message)+" ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }